<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full-screen"
      :loading="loading.content"
      notFooterPadding
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
      :visible.sync="modalVisible">
    <template #header>
      <div v-html="header" class="header"></div>
      <template v-if="viewOpType || editOpType">
        <gj-tag
            type="plain"
            shape="rectangle"
            :color="transferOrder.status | optionColor(TransferOrderEnum.statusOption)">
          {{ transferOrder.status | optionText(TransferOrderEnum.statusOption) }}
        </gj-tag>
      </template>
    </template>
    <template #content>
      <div v-if="false">
        <gj-input v-model="labelWidth" />
        <gj-input v-model="label1Width" />
        <gj-input v-model="label2Width" />
        <gj-input v-model="inputWidth" />
      </div>
      <div class="step-wrapper">
        <gj-steps
            :active="curStep"
            :steps="steps">
          <template v-for="(item, index) in stepTplList"
                    v-slot:[item.descriptionTpl]>
            <div :key="index" v-if="item.descriptionTpl !== 'complete'">
              <!-- <div>{{item.opUserLabel}}: {{item.opUserContent}}</div>
              <div>{{item.opTimeLabel}}: {{item.opTimeContent}}</div> -->
              <div>
                <i class="el-icon-user-solid"></i>
                <span> {{item.opUserContent}}</span>
              </div>
              <div>
                <i class="el-icon-time"></i>
                <span> {{item.opTimeContent}}</span>
              </div>
            </div>
          </template>
        </gj-steps>
      </div>
      <gj-area-title>基本信息</gj-area-title>
      <template v-if="addOpType || editOpType">
        <el-form
            ref="form"
            :model="form"
            :label-width="labelWidth">
          <el-row>
            <el-col :span="addOpType ? 6 : 8">
              <el-form-item
                  label="调出仓"
                  prop="warehouseId"
                  :rules="[
                    $gjRequired('请选择调出仓'),
                  ]">
                <gj-warehouse-select
                    v-if="addOpType"
                    v-model="form.warehouseId"
                    :fba="false"
                    active
                    noValid
                    :width="inputWidth"
                    placeholder="调出仓"
                ></gj-warehouse-select>
                <template v-else>{{data.warehouseName | defaultShow}}</template>
              </el-form-item>
            </el-col>
            <el-col :span="addOpType ? 6 : 8">
              <el-form-item
                  label="调入仓"
                  prop="arrivalWarehouseId"
                  :rules="[
                    $gjRequired('请选择调入仓'),
                  ]"
                  :label-width="label1Width">
                <gj-warehouse-select
                    v-if="addOpType"
                    v-model="form.arrivalWarehouseId"
                    :width="inputWidth"
                    active
                    noValid
                    @input="arrivalWarehouseIdInput($event)"
                    placeholder="调入仓"
                ></gj-warehouse-select>
                <template v-else>{{data.arrivalWarehouseName | defaultShow}}</template>
              </el-form-item>
            </el-col>
            <el-col v-if="addOpType" :span="6">
              <el-form-item
                  label="站点"
                  prop="arrivalMarketId"
                  :rules="[
                    $gjRequired('请选择站点'),
                  ]"
                  :label-width="label2Width">
                <gj-select
                    v-model="form.arrivalMarketId"
                    :width="inputWidth"
                    :options="marketOption"
                    :disabled="disableMarketSelect"
                    placeholder="站点"
                ></gj-select>
              </el-form-item>
            </el-col>
            <el-col :span="addOpType ? 6 : 8">
              <el-form-item
                  label="预计出运日期"
                  prop="expectShipmentDate"
                  :rules="[
                    $gjRequired('请选择预计出运日期'),
                  ]"
                  :label-width="label1Width">
                <gj-date-picker
                    v-model="form.expectShipmentDate"
                    :width="inputWidth"
                ></gj-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
              label="备注"
              prop="memo">
            <gj-input
                v-model="form.memo"
                width="88%">
            </gj-input>
          </el-form-item>
          <el-form-item
              label="上传附件"
              prop="desc">
            <gj-upload
                uploadPlain
                :container-biz-id="transferOrder ? transferOrder.id : null"
                container-type="TRANSFER"
                :acceptType="[]"
                :fileList.sync="form.files"
                specialUpload
            ></gj-upload>
          </el-form-item>
        </el-form>
      </template>
      <template v-if="viewOpType">
        <gj-desc-group
            :label-width="labelWidth">
          <el-row>
            <el-col :span="8">
              <gj-desc label="调出仓">{{data.warehouseName | defaultShow}}</gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="调入仓">{{data.arrivalWarehouseName | defaultShow}}</gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="预期出运日期">{{data.expectShipmentDate}}</gj-desc>
            </el-col>
          </el-row>
          <el-row>
            <gj-desc label="备注">{{data.memo | defaultShow}}</gj-desc>
          </el-row>
          <el-row>
            <gj-desc label="附件">
              <template v-if="form.files && form.files.length > 0">
                <gj-link
                    v-for="item in form.files"
                    :key="item.id"
                    @click="download(item.attId)"
                    style="margin-right: 8px;">
                  {{item.name}}
                </gj-link>
              </template>
              <template v-else>-</template>
            </gj-desc>
          </el-row>
        </gj-desc-group>
      </template>
      <!-- 详情 -->
      <template v-if="addOpType || editOpType">
        <div class="add-form">
          <app-op-transfer-order-product
            ref="productForm"
            :form="form"
            :op-type="opType"
            :transfer-order="transferOrder"
            :mount-to="$mountTo"
        ></app-op-transfer-order-product>
        </div>
      </template>
      <template v-else>
        <el-tabs value="product">
          <el-tab-pane label="产品明细" name="product">
            <app-op-transfer-order-product
                ref="productForm"
                :form="form"
                :op-type="opType"
                :transfer-order="transferOrder"
                :mount-to="$mountTo"
            ></app-op-transfer-order-product>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="log" lazy>
            <gj-log-table
                url="/supply/transfer/logPage"
                adaptParent
                :params="{
                  model: {
                    transferId: transferOrder.id
                  },
                }"
                :columns="TransferOrderEnum.logColumns"
                :offset-height="65"
            ></gj-log-table>
          </el-tab-pane>
        </el-tabs>
      </template>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <template v-if="addOpType">
        <gj-button
            :loading="loading.saveAsDraft"
            @click="saveOrAudit(true)"
        >保存为草稿</gj-button>
        <gj-button
            :loading="loading.audit"
            type="primary"
            @click="saveOrAudit(false)"
        >提审</gj-button>
      </template>
      <template v-if="viewOpType && !loading.content">
        <gj-button
            v-if="$permission('transfer:abolish')
              && (transferOrder.status === TransferOrderEnum.status.WAIT_REVIEW
              || transferOrder.status === TransferOrderEnum.status.REJECTED
              || transferOrder.status === TransferOrderEnum.status.WAIT_PICKED
              || transferOrder.status === TransferOrderEnum.status.WAIT_OUTBOUND
              || transferOrder.status === TransferOrderEnum.status.OUTBOUND)"
            @click="abolish()"
        >作废</gj-button>
        <gj-button
            v-if="$permission('transfer:audit') && transferOrder.status === TransferOrderEnum.status.WAIT_REVIEW"
            @click="auditFail()"
        >审核驳回</gj-button>
        <gj-button
            v-if="$permission('transfer:audit') && transferOrder.status === TransferOrderEnum.status.WAIT_REVIEW"
            type="primary"
            @click="auditPass()"
        >审核通过</gj-button>
        <gj-button
            v-if="$permission('transfer:audit') && transferOrder.status === TransferOrderEnum.status.REJECTED"
            :loading="loading.audit"
            type="primary"
            @click="saveOrAudit(false)"
        >提审</gj-button>

        <gj-button
            v-if="$permission('transfer:maintainShipment')
              && someIs(transferOrder.status, [TransferOrderEnum.status.WAIT_PICKED, TransferOrderEnum.status.WAIT_OUTBOUND, TransferOrderEnum.status.OUTBOUND])
              && transferOrder.arrivalMarketId !== '0'"
            @click="maintainFbaShipment"
        >维护货件</gj-button>

        <gj-button
            v-if="$permission('transfer:add') && transferOrder.status === TransferOrderEnum.status.WAIT_PICKED && !form.picking"
            type="primary"
            @click="startPick"
        >拣货</gj-button>
        <gj-button
            v-if="$permission('transfer:add') && transferOrder.status === TransferOrderEnum.status.WAIT_PICKED && form.picking"
            :loading="loading.finishPick"
            @click="finishPick()"
        >完成拣货</gj-button>
        <gj-button
            v-if="$permission('transfer:add') && transferOrder.status === TransferOrderEnum.status.WAIT_PICKED && form.picking"
            type="primary"
            @click="finishPickAndOutbound()"
        >完成拣货并出库</gj-button>

        <gj-button
            v-if="$permission('transfer:add') && transferOrder.status === TransferOrderEnum.status.WAIT_OUTBOUND"
            type="primary"
            @click="outbound()"
        >出库</gj-button>
      </template>
      <template v-if="editOpType">
        <gj-button
            v-if="$permission('transfer:add')
              && transferOrder.status === TransferOrderEnum.status.DRAFT"
            :loading="loading.saveAsDraft"
            @click="saveOrAudit(true)"
        >保存为草稿</gj-button>
        <gj-button
            v-if="$permission('transfer:audit')
              && (transferOrder.status === TransferOrderEnum.status.DRAFT || transferOrder.status === TransferOrderEnum.status.REJECTED)"
            :loading="loading.audit"
            type="primary"
            @click="saveOrAudit(false)"
        >提审</gj-button>
      </template>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin} from "@/minxins";
  import {OpEnum} from "@/utils/options";
  import AppOpTransferOrderProduct from "./components/product/op-transfer-order-product";
  import {
    abolishTransferOrder,
    addTransferOrder, auditTransferOrder, failTransferOrder,
    getTransferMarket,
    getTransferOrder, outboundTransferOrder, passTransferOrder, pickTransferOrder,
    updateTransferOrder
  } from "@/api/warehouse";
  import {isMeaningful} from "@/utils/common";
  import {convertToDate} from "@/utils/date.util";
  import {TransferOrderEnum} from "../../enum";
  import {downloadAttFile} from "@/api/common";
  import AppMaintainFbaShipmentModal from "../maintain-shipment/maintain-fba-shipment-modal";

  export default {
    name: "app-op-transfer-order-modal",
    components: {AppOpTransferOrderProduct},
    mixins: [modalMixIn, formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin],
    props: {
      header: {
        required: true
      },
      opType: {
        required: true
      },
      transferOrder: {
        default: null
      },
      pick: {
        default: false
      },
      deliveryPlan:{
        default:null
      }
    },
    data() {
      return {
        data: {},
        form: {
          id: null,
          warehouseId: null,
          arrivalWarehouseId: null,
          arrivalMarketId: null,
          expectShipmentDate: null,
          memo: null,
          picking: false,
          files: [],
          items: []
        },
        labelWidth: '100px',
        label1Width: '100px',
        label2Width: '100px',
        inputWidth: '150px',
        curStep: 0,
        steps: [],
        loading: {
          content: false,
          saveAsDraft: false,
          audit: false,
          finishPick: false,
        },
        OpEnum: OpEnum,
        marketOption: [],
        TransferOrderEnum: TransferOrderEnum,
      }
    },
    created() {
      const normalSteps = [
        {
          title: '创建',
          id: 'create',
          opUserLabel: '创建人',
          opTimeLabel: '创建时间'
        },
        {
          title: '审核',
          id: 'review',
          opUserLabel: '审核人',
          opTimeLabel: '审核时间'
        },
        {
          title: '拣货',
          id: 'pick',
          opUserLabel: '操作人',
          opTimeLabel: '操作时间'
        },
        {
          title: '出库',
          id: 'outbound',
          opUserLabel: '操作人',
          opTimeLabel: '操作时间'
        },
        {
          id: 'complete',
          title: '完成'
        },
      ];
      if (this.viewOpType || this.editOpType) {
        this.loading.content = true;
        getTransferOrder(this.transferOrder.id)
          .then(data => {
            this.data = data;
            this.form = this.data;
            if (this.pick) {
              this.form.picking = true;
            }
            // 设置附件
            if (data.attachments) {
              this.form.files = data.attachments.map(item => ({
                name: item.fileName,
                attId: item.id,
              }));
            }
            const processList = data.processList;
            // 设置流程节点
            if (this.transferOrder.status === TransferOrderEnum.status.ABOLISHED) {
              const prefix = {
                create: '创建',
                review: '审核'
              };
              this.steps = processList.map(item => {
                const label = prefix[item.processNode] ? prefix[item.processNode] : '操作';
                return {
                  descriptionTpl: item.processNode,
                  title: item.processDesc,
                  opUserLabel: `${label}人`,
                  opUserContent: item.updateUserName,
                  opTimeLabel: `${label}时间`,
                  opTimeContent: item.operationDate
                };
              });
              this.curStep = processList.length;
            } else {
              if (this.transferOrder.status === TransferOrderEnum.status.REJECTED) {
                normalSteps[1].title = '审核驳回';
              }
              this.steps = normalSteps;
              processList.forEach(item => {
                const step = this.steps.find(step => step.id === item.processNode);
                if (step) {
                  step.descriptionTpl = item.processNode;
                  step.opUserContent = item.updateUserName;
                  step.opTimeContent = item.operationDate;
                }
              });
              this.curStep = processList.length === this.steps.length
                ? this.steps.length
                : processList.length;
            }
          })
          .complete(() => this.loading.content = false);
      }
      if (this.addOpType) {
        this.curStep = 0;
        this.steps = normalSteps;
        if(this.deliveryPlan){  // 通过采购计划生成调拨单
          this.getDeliveryPlan(this._.cloneDeep(this.deliveryPlan));
        }
      }
    },
    computed: {
      disableMarketSelect() {
        return this.marketOption && this.marketOption.length === 1
      },
      stepTplList() {
        return this.steps.filter(item => isMeaningful(item.descriptionTpl));
      }
    },
    methods: {
      getDeliveryPlan(res){
        res.items = res.itemList;
        res.files=[];
        this.data = res;
        this.form = this.data;
        this.arrivalWarehouseIdInput(res.arrivalWarehouseId)
      },
      download(fileId) {
        downloadAttFile(fileId);
      },
      arrivalWarehouseIdInput(warehouseId) {
        if (isMeaningful(warehouseId)) {
          getTransferMarket({
            arrivalWarehouseId: warehouseId
          })
            .then(data => {
              this.marketOption = data;
              if (data && data.length === 1) {
                this.form.arrivalMarketId = data[0].id;
              }
            })
        }
      },
      saveOrAudit(saveDraft) {
        if (this.formValidate()) {
          if (saveDraft) {
            this.loading.saveAsDraft = true;
          } else {
            this.loading.audit = true;
          }
          Promise.resolve(this.mapToFormParams(saveDraft))
            .then((params) => {
              if (this.addOpType) {
                return addTransferOrder(params);
              }
              if (this.editOpType) {
                return updateTransferOrder(params);
              }
            })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                if (this.addOpType) {
                  this.$gjMessage.success(`生成调拨单：${res.data}`);
                  this.$emit('created');
                }
                if (this.editOpType) {
                  this.$gjMessage.success('操作成功');
                  this.$emit('updated');
                }
                this.$gjDestroy();
              });
            })
            .complete(() => {
              if (saveDraft) {
                this.loading.saveAsDraft = false;
              } else {
                this.loading.audit = false;
              }
            });
        }
      },
      mapToFormParams(saveDraft) {
        if (this.addOpType) {
          return {
            warehouseId: this.form.warehouseId,
            arrivalMarketId: this.form.arrivalMarketId,
            arrivalWarehouseId: this.form.arrivalWarehouseId,
            expectShipmentDate: convertToDate(this.form.expectShipmentDate),
            memo: this.form.memo,
            saveDraft,
            attachmentIds: this.form.files.map(item => item.attId),
            items: this.form.items.map(item => ({
              arrivalWarehouseId: this.form.arrivalWarehouseId,
              warehouseId: this.form.warehouseId,
              asin: item.asin,
              categoryId: item.categoryId,
              fnsku: item.fnsku,
              memo: item.memo,
              msku: item.msku,
              packageWeight: item.packageWeight,
              productType: item.productType,
              quantity: item.quantity,
              singleQuantity: item.singleQuantity,
              shipPlanCodeList:item.shipPlanCodeList || [],
              sku: item.sku,
              volume: item.volume,
            }))
          }
        }
        if (this.editOpType) {
          return {
            id: this.transferOrder.id,
            memo: this.form.memo,
            expectShipmentDate: convertToDate(this.form.expectShipmentDate),
            saveDraft,
            items: this.form.items.map(item => ({
              id: item.id,
              quantity: item.quantity,
              memo: item.memo,
              asin: item.asin,
              categoryId: item.categoryId,
              fnsku: item.fnsku,
              msku: item.msku,
              packageWeight: item.packageWeight,
              productType: item.productType,
              singleQuantity: item.singleQuantity,
              sku: item.sku,
              volume: item.volume,
            }))
          }
        }
      },
      // 提审
      audit() {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            content: `确定要提审[${this.transferOrder.code}]吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              auditTransferOrder([this.transferOrder.id])
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                    this.$emit('resetPage');
                    this.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      // 作废
      abolish() {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: `作废<span class="modal-secondary-title">${this.transferOrder.code}</span>`,
            label: '作废理由',
            labelWidth: '75px',
            contentStyle: {padding: '18px 40px 4px 30px'}
          },
          on: {
            submit: (reason) => {
              modal.confirmLoading = true;
              abolishTransferOrder(this.transferOrder.id, reason)
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                    this.$emit('resetPage');
                    this.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      // 审核驳回
      auditFail() {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: `驳回<span class="modal-secondary-title">${this.transferOrder.code}</span>`,
            label: '驳回理由',
            labelWidth: '75px',
            contentStyle: {padding: '18px 40px 4px 30px'}
          },
          on: {
            submit: (memo) => {
              modal.confirmLoading = true;
              failTransferOrder({
                ids: [this.transferOrder.id],
                memo,
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                    this.$emit('resetPage');
                    this.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      // 审核通过
      auditPass() {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            content: `确定要通过[${this.transferOrder.code}]吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              passTransferOrder([this.transferOrder.id])
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                    this.$emit('resetPage');
                    this.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      maintainFbaShipment() {
        this.$gjCreate(AppMaintainFbaShipmentModal, {
          props: {
            transferOrders: [this.transferOrder],
          },
          on: {
            maintained: () => {
              this.$emit('resetPage');
              this.$gjDestroy();
            }
          }
        })
      },
      // 开始拣货
      startPick() {
        this.$set(this.form, 'picking', true);
      },
      // 完成拣货
      finishPick() {
        if (this.$refs['productForm'].formValidate()) {
          this.loading.finishPick = true;
          pickTransferOrder({
            id: this.transferOrder.id,
            pick: true,
            items: this.form.items.map(item => ({
              id: item.id,
              quantity: item.pickQuantity
            }))
          })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('拣货成功');
                this.$emit('resetPage');
                this.$gjDestroy();
              })
            })
            .complete(() => this.loading.finishPick = false);
        }
      },
      // 完成拣货并出库
      finishPickAndOutbound() {
        if (!this.$refs['productForm'].formValidate()) {
          return;
        }
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '拣货并出库',
            content: `确定拣货并出库？出库后，该调拨单状态更新为“已出库”`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              pickTransferOrder({
                id: this.transferOrder.id,
                pick: false,
                items: this.form.items.map(item => ({
                  id: item.id,
                  quantity: item.pickQuantity
                }))
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                    this.$emit('resetPage');
                    this.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      // 出库
      outbound() {
        if (!this.$refs['productForm'].formValidate()) {
          return;
        }
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '出库',
            content: `确定出库？出库后，该调拨单状态更新为“已出库”`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              outboundTransferOrder(this.transferOrder.id)
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                    this.$emit('resetPage');
                    this.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      formValidate() {
        if (!this.$gjFormValidate()) {
          return false;
        }
        return this.$refs['productForm'].formValidate();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    display: inline-block;
    margin-right: 8px;
  }
  .step-wrapper {
    padding: 0 20px 10px;
    margin-bottom: 10px;
  }
  /deep/ .gj-modal--custom .el-dialog {
    height: 100%;
    width: 1300px;
  }
  /deep/ .el-step__head.is-wait{
    .el-step__icon.is-text{
      border-color: #D8DADD;
    }
    .el-step__icon-inner{
      color: #666;
    }
  }
 /deep/ .gj-table-item .el-form-item__error{
   margin-top: 7px;
   line-height: 0;
 }
 /deep/ .el-tabs{
   flex: 1;
   overflow: auto;
   display: flex;
   flex-direction: column;
   min-height: 460px;
   .el-tabs__content{
     flex: 1;
     overflow: auto;
   }
   .el-tab-pane{
     height: 100%;
   }
 }
 .add-form{
   flex: 1;
   overflow: auto;
   min-height: 440px;
   /deep/ .el-form{
     display: flex;
     flex-direction: column;
     .wrapper-loading{
       flex: 1;
       overflow: auto;
     }
   }
 }
</style>

